import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/footer/footer.component.ts